export default __webpack_public_path__ + "static/media/Allas Workshop.8f6b2b69.png";